/* eslint-disable */
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
import { MdKeyboardArrowDown, MdKeyboardArrowRight } from "react-icons/md";
// chakra imports

export function SidebarLinks(props) {
  const [openMenus, setOpenMenus] = useState({});
  let location = useLocation();
  const { routes } = props;

  const toggleMenu = (name) => {
    setOpenMenus((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      const isActive = route?.name == "CMS" ?
        location.pathname.includes('privacy-policy') ||
        location.pathname.includes('terms-and-conditions') ||
        location.pathname.includes('about-us') : activeRoute(route.path);
      const hasChildren = route.children && route.children.length > 0;
      const isOpen = openMenus[route.name];

      if (route.layout === "/admin" || route.layout === "/auth") {
        return (
          <Link key={index} to={route.layout + "/" + route.path}>
            {/* <div className="relative mb-3 flex hover:cursor-pointer"> */}
            <div
              className="relative mb-3 w-full flex items-center justify-between px-8 hover:cursor-pointer"
              onClick={() => hasChildren && toggleMenu(route.name)}
            >
              <div className="flex w-full items-center justify-between">
                <li className="my-[3px] flex cursor-pointer items-center">
                  <span
                    className={`${isActive
                      ? "font-bold text-brand-500 dark:text-white"
                      : "font-medium text-gray-600"
                      }`}
                  >
                    {route.icon || <DashIcon />}
                  </span>
                  <p
                    className={`leading-1 ml-4 ${isActive
                      ? "font-bold text-navy-700 dark:text-white"
                      : "font-medium text-gray-600"
                      }`}
                  >
                    {route.name}
                  </p>
                </li>
                {hasChildren && (
                  <div className="text-gray-700">
                    {isOpen ? <MdKeyboardArrowDown /> : <MdKeyboardArrowRight />}
                  </div>
                )}
              </div>

              {isActive ? (
                <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
              ) : null}
            </div>

            {hasChildren && isOpen && (
              <ul className="ml-16 mb-4">
                {route.children.map((child, idx) => {
                  const isChildActive = activeRoute(child.path);
                  return (
                    <li key={idx}>
                      <Link
                        to={child.layout + "/" + child.path}
                        className={`block rounded-md py-1 px-2 text-md ${isChildActive
                          ? "text-brand-500 font-semibold"
                          : "text-gray-600"
                          } hover:text-brand-600`}
                      >
                        {child.name}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            )}
            {/* </div> */}
          </Link>
        );
      }
    });
  };
  // BRAND
  return createLinks(routes);
}

export default SidebarLinks;
